import React from 'react'

import { IconExport } from '@avantstay/backoffice-vectors'

import { FrameButton, FrameButtonType } from '../Frame'

interface ShareButtonProps extends FrameButtonType {
  onClick: VoidFunction
}

export const CopyToClipboardShareButton = ({ onClick }: ShareButtonProps) => {
  return <FrameButton buttonText="Share Link" icon={<IconExport />} onClick={onClick} />
}
